import React, { useEffect, useState } from 'react';
import { KeyboardCodes } from '../Helpers';

const Button = ({ className, isDisabled = false, isSelected, label, onClick, onKeyDown, style }) => {
    const [selected, setSelected] = useState(false);

    const internalKeyDown = e => {
        if ([KeyboardCodes.ENTER, KeyboardCodes.SPACE].includes(e.keyCode)) {
            onKeyDown();
        }
    };

    useEffect(() => {
        isSelected && setSelected(true);
    }, [isSelected]);

    return (
        <button
            style={style}
            className={selected ? `clx-step__button selected ${className}` : `clx-step__button ${className}`}
            disabled={isDisabled}
            type="button"
            onClick={onClick}
            onKeyDown={e => internalKeyDown}
        >
            {label}
        </button>
    );
};

export default Button;
